<template>
  <div
    v-show="this.$store.state.layout !== 'landing'"
    class="card card-plain shadow-none"
    id="sidenavCard"
  >
  </div>
</template>

<style scoped>
  .btn.btn-link {
    padding: 0;
  }
  p {
    font-size: 0.875rem;
    margin: 0;
  }
</style>
<script>
export default {
    name: "sidenav-card",
    props: ["textPrimary", "textSecondary", "iconClass"],
};
</script>
